import { render, staticRenderFns } from "./BookingFormDistance.vue?vue&type=template&id=bd257878"
import script from "./BookingFormDistance.vue?vue&type=script&lang=ts"
export * from "./BookingFormDistance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports